import { 
  ADD_CART_ITEM, 
  ADD_CART_ITEMS,
  EDIT_CART_ITEM,
  REMOVE_CART_ITEM,
  CLEAR_CART, 
} from "../actions/cart";
import { MISSING_ITEMS_WARNING } from "../actions/orderSummary";

export default function cart(state = {
  items: [],
  file: null,
}, action) {
  switch (action.type) {
    case CLEAR_CART:
      return {
        ...state,
        items: [],
        file: null,
      };
    case ADD_CART_ITEM:
      return {
        ...state,
        items: [...state.items, action.payload.item],
      };
    case ADD_CART_ITEMS:
      const existingItems = state.items.map(cartItem => {
        const isDuplicate = action.payload.items.some(item => {
          return item.article_number === cartItem.article_number;
        })
        return {
          ...cartItem,
          quantity: isDuplicate ? Math.min(cartItem.quantity + 1, 99) : cartItem.quantity
        }
      });
      const newItems = action.payload.items.filter(item => {
        const isDuplicated = state.items.some(cartItem => {
          return (cartItem.article_number === item.article_number);
        });
        return !isDuplicated;
      }).map(item => {
        return {
          ...item,
          quantity: item.quantity || 1,
        }
      });
      return {
        ...state,
        items: [...existingItems, ...newItems],
        file: action.payload.file,
      };
    case EDIT_CART_ITEM:
      return {
        ...state,
        items: state.items.map(item => {
          if (item.article_number === action.payload.articleNumber) {
            return {
              ...item,
              quantity: action.payload.quantity
            }
          }
          else {
            return item;
          }
        })
      };
    case REMOVE_CART_ITEM:
      return {
        ...state,
        items: state.items.filter(item => {
          return item.article_number !== action.payload.articleNumber
        })
      };
    case MISSING_ITEMS_WARNING:
      return {
        ...state,
        items: state.items.filter(item => {
          return !action.payload.missingItems.some(missingItem => {
            return missingItem.article_number === item.article_number
          })
        })
      }
    default:
      return state;
  }
}